import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import CustomTextField from '../forgot-password/CustomTextField'
import CustomSelect from '../forgot-password/CustomSelect'
import CustomButton from '../forgot-password/CustomButton'
import { getSchoolFormationRequest } from '../../services/api.service';
import { Typography } from '@material-ui/core';
import Loader from '../../components/loader';
import './loader-style/index.scss';

export const formations = [
  {key: 'ING', name: 'École d’ingénieur'},
  {key: 'BUS', name: 'École de commerce'},
  {key: 'ENS', name: 'École Normale Supérieure'},
  {key: 'SCP', name: 'Institut d’Etudes Politiques'},
  {key: 'DRO', name: 'Faculté de Droit' },
  {key: 'MED', name: 'Faculté de Médecine' },
  {key: 'SCI', name: 'Faculté de Sciences' },
  {key: 'OTH', name: 'Autres'},
];

export function RenderIntroBlock({ onClick }) {
  return (
    <React.Fragment>
      <ul
        style={{
          listStyle: 'disc',
          marginInline: '1em',
          fontSize: '1.2rem',
          marginBlock: '2em',
          paddingLeft: '1em',
        }}
      >
        <li>Etre en Grande École post prépa ou titulaire d’un BAC + 3 “validé”</li>
        <li>Avoir de l'expérience dans l’enseignement ou une forte appétence pour transmettre et encourager des élèves</li>
        <li>Être fièr.e de partager ton savoir et l’envie de t'impliquer sérieusement</li>
      </ul>

      <div className="footer">
        <CustomButton
            color="secondary"
            onClick={onClick}
          >
            C’est moi !
          </CustomButton>
      </div>
    </React.Fragment>
  );
}

export function SelectReferal({ isSubmitting, referral, setReferral }) {
  return (
    <React.Fragment>
      {[
        'Par mon Ecole',
        'Bouche à oreille',
        'Recherche internet',
        'LinkedIn',
        'Gens de Confiance',
        'Facebook',
        'Leboncoin',
        'Not Specified'
      ].includes(referral) && <div style={{ display: 'flex', flexFlow: 'wrap', marginRight: -8, justifyContent: 'center' }}>
        <div style={{cursor: 'pointer'}} className={`referral-item ${referral === 'Par mon Ecole' ? 'active' : ''}`} onClick={() => setReferral('Par mon Ecole')}>
          <div style={{ color: '#2777b5' }}>
            <img width={40} src="/img/icons/social/school.png" alt="School"/><br />
            Par mon Ecole (BDE, asso…)
          </div>
        </div>
        <div style={{cursor: 'pointer'}} className={`referral-item ${referral === 'Bouche à oreille' ? 'active' : ''}`} onClick={() => setReferral('Bouche à oreille')}>
          <div style={{ color: '#2777b5' }}>
            <img width={40} src="/img/icons/social/mouthtoear.png" alt="Ear"/><br />
            Bouche à oreille
          </div>
        </div>
        <div style={{cursor: 'pointer'}} className={`referral-item ${referral === 'Recherche internet' ? 'active' : ''}`} onClick={() => setReferral('Recherche internet')}>
          <div style={{ color: '#2777b5' }}>
            <img width={40} src="/img/icons/social/internet.png" alt="Internet"/><br />
            Recherche internet
          </div>
        </div>
        <div style={{cursor: 'pointer'}} className={`referral-item ${referral === 'LinkedIn' ? 'active' : ''}`} onClick={() => setReferral('LinkedIn')}>
          <div style={{ color: '#2777b5' }}>
            <img width={40} src="/img/icons/social/new/linkedin.png" alt="Gens de Confiance"/><br />
            LinkedIn
          </div>
        </div>
        <div style={{cursor: 'pointer'}} className={`referral-item ${referral === 'Gens de Confiance' ? 'active' : ''}`} onClick={() => setReferral('Gens de Confiance')}>
          <img width={96} src="/img/icons/social/confiance.png" alt="Gens de Confiance"/>
        </div>
        <div style={{cursor: 'pointer'}} className={`referral-item ${referral === 'Facebook' ? 'active' : ''}`} onClick={() => setReferral('Facebook')}>
          <div style={{ color: '#45619d' }}>
            <img width={40} src="/img/icons/social/new/facebook.png" alt="Facebook"/><br />
            Facebook
          </div>
        </div>
        <div style={{cursor: 'pointer'}} className={`referral-item ${referral === 'Leboncoin' ? 'active' : ''}`} onClick={() => setReferral('Leboncoin')}>
          <div style={{ color: '#45619d' }}>
            <img width={40} src="/img/icons/social/new/leboncoin.png" alt="Le bon coin"/><br />
            Leboncoin
          </div>
        </div>
        <div style={{cursor: 'pointer'}} className={`referral-item ${![
          'Par mon Ecole',
          'Bouche à oreille',
          'Recherche internet',
          'LinkedIn',
          'Gens de Confiance',
          'Facebook',
          'Leboncoin',
          'Not Specified'
        ].includes(referral) ? 'active' : ''}`} onClick={() => setReferral('')}>Autre</div>
      </div>}
      {![
        'Par mon Ecole',
        'Bouche à oreille',
        'Recherche internet',
        'LinkedIn',
        'Gens de Confiance',
        'Facebook',
        'Leboncoin',
        'Not Specified'
      ].includes(referral) && <CustomTextField
        name="referral"
        placeholder="Si autre, par quel canal ?"
        type="text"
        value={referral}
        onChange={(e) => setReferral(e.target.value)}
        style={{
          marginBottom: 16,
        }}
      />}
    </React.Fragment>
  );
}


export default function RegisterTutorForm({ email, onSubmit, onSuccess, onFailure }) {
  const [step, setStep] = useState('intro')
  const [is_Loading,setIsLoading] = useState(false)
  const [schools, setSchools] = useState([])
  const [referral, setReferral] = useState('Not Specified')

  function updateSchool(formation) {
    setSchools([]);
    getSchoolFormationRequest(formation).then(({ schools = [] }) =>
      setSchools(schools)
    );
  };

  return (<div>
    <Typography variant="h5" align="center" style={{ textAlign: 'center', margin: '24px 0 32px 0'}}>
      {step === 'intro' || step === 'form'
         ? 'Conditions pour dispenser des cours ?'
         : 'Comment as-tu entendu parler de nous ?'
        }
       {is_Loading && <Loader />}
    </Typography>


    <React.Fragment>
      {step === 'intro'
      ? <RenderIntroBlock onClick={() => setStep('form')} />
      : <Formik
        initialValues={{
          email,
          firstName: '',
          lastName: '',
          phoneNumber: '',
          // formation: '',
          // selectedSchool: '',
          password: '',
          referral: '',
        }}
        validate={(values) => {
          const errors = {}

          if (!values.email) {
            errors.email = 'Votre email est nécessaire'
          } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = 'Email Incorrect'
          }
          
          if (!values.firstName) {
            errors.firstName = 'Votre prénom est nécessaire'
          }
    
          if (!values.lastName) {
            errors.lastName = 'Votre nom est nécessaire'
          }

          if (!values.phoneNumber) {
            errors.phoneNumber = 'Votre numéro de téléphone est nécessaire'
          } else if (!/^(0)([1-9]){1}([\d]){8}$/i.test(values.phoneNumber)) {
            errors.phoneNumber = 'Numero de téléphone invalide'
          }
    
    
          // if (!values.formation) {
          //   errors.formation = 'Votre Formation est nécessaire'
          // }
    
          // if (!values.selectedSchool) {
          //   errors.selectedSchool = 'Votre Ecole est nécessaire'
          // }
    
          if (!values.password) {
            errors.password = 'Votre mot de passe est nécessaire'
          }
    
          if (values.password.length < 8) {
            errors.password = 'Votre mot de passe doit contenir au minimum 8 caractères'
          }

          if (referral === '' && step === 'referral') {
            errors.referral = 'Merci de préciser un canal s’il te plait :-)'
          }
          return errors
        }}
        onSubmit={(values, { setSubmitting }) => {
          if (step === 'form') {
            setStep('referral');
            setIsLoading(false)
            setSubmitting(false);
          } else if (step === 'referral') {
            // setSubmitting(true)
            const data = {
              ...values,
              referral,
            }

            onSubmit(data)
              .then((data) => {
                setSubmitting(false);
                onSuccess(data);
                setIsLoading(false)
              })
              .catch((error) => {
                setSubmitting(false);
                onFailure(error);
                setStep('form');
                setIsLoading(false)
              });
          }
        }}
      >
        {({ touched, errors, handleChange, submitForm, isSubmitting }) => (
          <Form>
            {step === 'form'
            ? <React.Fragment>
                <CustomTextField
                  name="firstName"
                  placeholder="Prénom"
                  type="email"
                  required
                />
                <CustomTextField
                  name="lastName"
                  placeholder="Nom"
                  type="email"
                  required
                />
                {/* <CustomSelect
                  name="formation"
                  placeholder="Type d'école"
                  items={formations}
                  error={touched.formation && errors.formation}
                  onChange={(e) => {
                    handleChange(e);
                    updateSchool(e.target.value);
                  }}
                  required
                  style={{ marginBottom: 0 }}
                />
                {schools.length > 0 && <CustomSelect
                  name="selectedSchool"
                  placeholder="Choix d'une école"
                  items={schools}
                  error={touched.selectedSchool && errors.selectedSchool}
                  required
                  style={{ marginBottom: 0, maxWidth: 395 }}
                />} */}
                <CustomTextField
                  name="phoneNumber"
                  placeholder="Téléphone"
                  type="text"
                  required
                />
                <CustomTextField
                  name="email"
                  placeholder="Adresse e-mail"
                  type="email"
                  required
                />
                <CustomTextField
                  name="password"
                  placeholder="Mot de passe"
                  type="password"
                  required
                  style={{ marginBottom: 16 }}
                />
              </React.Fragment> 
              : <SelectReferal isSubmitting={isSubmitting} referral={referral} setReferral={(referral) => {
                  if (isSubmitting) {
                    return;
                  }
                  const maping = {
                    'Par mon Ecole':'Ecole',
                    'Bouche à oreille':'Reco',
                    'Recherche internet':'Internet',
                    'LinkedIn':'LinkedIn',
                    'Gens de Confiance':'GDC',
                    'Facebook':'Facebook',
                    'Leboncoin':'LBC'
                  }
                  if([
                    'Par mon Ecole',
                    'Bouche à oreille',
                    'Recherche internet',
                    'LinkedIn',
                    'Gens de Confiance',
                    'Facebook',
                    'Leboncoin'
                  ].includes(referral)) {
                    setReferral(maping[referral])
                    setIsLoading(true)
                    submitForm();
                  }else{
                    setReferral(referral)
                  }
                }} />}
            {(![
              'Par mon Ecole',
              'Ecole',
              'Bouche à oreille',
              'Reco',
              'Recherche internet',
              'Internet',
              'LinkedIn',
              'Gens de Confiance',
              'GDC',
              'Facebook',
              'Leboncoin',
              'LBC',
              'Not Specified'
            ].includes(referral) || step === 'form') && <CustomButton
              color="secondary"
              onClick={()=>{setIsLoading(true);submitForm()}}
              disabled={isSubmitting}
            >
              CONTINUER
            </CustomButton>}
          </Form>
        )}
      </Formik>}
    </React.Fragment>
    </div>)
  };
